import { render, staticRenderFns } from "./manageAbout.vue?vue&type=template&id=8c1829ec&"
import script from "./manageAbout.vue?vue&type=script&lang=js&"
export * from "./manageAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports